/*
 * @Descripttion: 轮询管理器，支持开始，停止轮询方法，在轮询结束后需要手动调用stop方法进行轮询停止
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-06-22 16:50:26
 * @LastEditors: liyong
 * @LastEditTime: 2022-06-22 17:23:11
 * @FilePath: /partner.chaoyongtuan.com/src/utils/loop.js
 * 
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved. 
 */
export default class LoopManager {
  constructor(cb, interval = 2000) {
    this.cb = cb;
    this.interval = interval;
    this.isStop = true;
    this.timer = null;
    this.start();
  }
  stop() {
    this.isStop = true;
    clearTimeout(this.timer);
  }
  async loop() {
    try {
      await this.cb(this.stop);
    } catch (error) {
      throw new Error(error);
    }
    if(this.isStop) {
      clearTimeout(this.timer);
      this.timer = null;
      return;
    }
    return (this.timer = setTimeout(this.loop.bind(this), this.interval));
  }
  start() {
    if(this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.isStop = false;
    this.loop();
  }
}